import { useTranslation } from "react-i18next"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm, UseFormProps } from "react-hook-form"
import { object, ref, string } from "yup"

export interface ISendSignUpForm {
  token: string
  type: string
  first_name: string
  last_name: string
  birthdate: string
  phone: string
  address: {
    street_1: string
    street_2?: string
    city: string
    zip: string
  }
  password?: string
  password_confirmation?: string
}

export function useRegistrationForm(defaultValues?: Partial<ISendSignUpForm>) {
  const { t } = useTranslation()

  const schema = object({
    token: string().required(),
    type: string().required(
      t("global.requiredField", { field: t("global.type") })
    ),
    first_name: string().required(
      t("global.requiredField", { field: t("global.first_name") })
    ),
    last_name: string().required(
      t("global.requiredField", { field: t("global.last_name") })
    ),
    birthdate: string(),
    phone: string().nullable() /* .required(
      t("global.requiredField", { field: t("global.phone") })
    ) */,
    address: object({
      street_1: string(),
      street_2: string(),
      city: string(),
      zip: string(),
    }),
    password: string()
      .nullable()
      .test("min", t("auth.invalidPassword"), (value) => {
        return !value || value.length >= 6
      }),
    password_confirmation: string()
      .nullable()
      .when("password", {
        is: (password: string) => password && password.length > 0,
        then: (schema) =>
          schema
            .required(
              t("global.requiredField", {
                field: t("auth.password_confirmation"),
              })
            )
            .oneOf([ref("password")], t("auth.passwordsMustMatch")),
        otherwise: (schema) => schema.nullable(),
      }),
  }).required()

  return useForm<ISendSignUpForm>({
    resolver: yupResolver(schema),
    defaultValues,
  })
}
